import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetContactSaleByLanguageParams,
  BackendErrorEntity,
  ContactSaleEntity,
  InsertContactSaleFormRequestBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiInsertContactSaleFormRequest = (
    insertContactSaleFormRequestBodyDto: MaybeRef<InsertContactSaleFormRequestBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      insertContactSaleFormRequestBodyDto = unref(insertContactSaleFormRequestBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/contactSaleFormRequest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: insertContactSaleFormRequestBodyDto
    },
      options);
    }
  


export const getApiInsertContactSaleFormRequestMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInsertContactSaleFormRequest>>, TError,{data: BodyType<InsertContactSaleFormRequestBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInsertContactSaleFormRequest>>, TError,{data: BodyType<InsertContactSaleFormRequestBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInsertContactSaleFormRequest>>, {data: BodyType<InsertContactSaleFormRequestBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiInsertContactSaleFormRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiInsertContactSaleFormRequestMutationResult = NonNullable<Awaited<ReturnType<typeof apiInsertContactSaleFormRequest>>>
    export type ApiInsertContactSaleFormRequestMutationBody = BodyType<InsertContactSaleFormRequestBodyDto>
    export type ApiInsertContactSaleFormRequestMutationError = ErrorType<BackendErrorEntity>

    export const useApiInsertContactSaleFormRequest = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInsertContactSaleFormRequest>>, TError,{data: BodyType<InsertContactSaleFormRequestBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiInsertContactSaleFormRequest>>,
        TError,
        {data: BodyType<InsertContactSaleFormRequestBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiInsertContactSaleFormRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetContactSaleByLanguage = (
    params: MaybeRef<ApiGetContactSaleByLanguageParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<ContactSaleEntity>(
      {url: `/contactSaleFormRequest/getContactSaleByLanguage`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetContactSaleByLanguageQueryKey = (params: MaybeRef<ApiGetContactSaleByLanguageParams>,) => {
    return ['contactSaleFormRequest','getContactSaleByLanguage', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetContactSaleByLanguageQueryOptions = <TData = Awaited<ReturnType<typeof apiGetContactSaleByLanguage>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiGetContactSaleByLanguageParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetContactSaleByLanguage>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetContactSaleByLanguageQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetContactSaleByLanguage>>> = () => apiGetContactSaleByLanguage(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetContactSaleByLanguage>>, TError, TData> 
}

export type ApiGetContactSaleByLanguageQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetContactSaleByLanguage>>>
export type ApiGetContactSaleByLanguageQueryError = ErrorType<BackendErrorEntity>



export function useApiGetContactSaleByLanguage<TData = Awaited<ReturnType<typeof apiGetContactSaleByLanguage>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiGetContactSaleByLanguageParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetContactSaleByLanguage>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetContactSaleByLanguageQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



